import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../../../styles/constants.style";

export const AddGoalWrapper = styled.div`
  .add-goal-modal-box {
    padding: 0 16px;

    .MuiGrid2-root {
      margin: 10px 0;
    }
  }

  .content {
    width: 100%;
    padding: 0px;

    ${responsive.MOBILE`
            padding: 16px 16px 0 16px;
            overflow-x: hidden;
            width: 100%;
            box-sizing: border-box;
      
          .MuiFormControl-root,
          .MuiTextField-root {
            width: 100%;
            box-sizing: border-box;
          }
          
          &:first-child {
            padding-bottom: 16px;
          }
        
          `}
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100% !important;
  }

  .notes-input-box-wrapper {
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding-bottom: 24px;

    ${responsive.MOBILE`
        grid-template-columns: 1fr;
        width: 100%;
        padding-bottom: 16px;
      `}
    .notes-input {
      .MuiInputBase-root {
        height: 100px;
        background: ${COLORS.cirrus_black1};
        padding: 0px;
      }
    }
  }
`;
